/* eslint-disable camelcase */

/* camel case disabled for strings to properly match record */
import type { FC } from 'react'
import {
  AbsenceFullDayIcon,
  AbsenceHalfDayEveningIcon,
  AbsenceHalfDayMorningIcon,
} from 'redesign/components/atoms/Icon'
import type { IconProps } from 'redesign/components/atoms/Icon/types'
import type { AbsencePeriodsT } from 'shared/constants'

export const ABSENCE_PERIOD_ICONS: Record<AbsencePeriodsT, FC<IconProps>> = {
  full_day: AbsenceFullDayIcon,
  half_day_morning: AbsenceHalfDayMorningIcon,
  half_day_afternoon: AbsenceHalfDayEveningIcon,
}

export const ABSENCE_PERIOD_TRANSLATION: Record<AbsencePeriodsT, string> = {
  full_day: '',
  half_day_morning: 'morning',
  half_day_afternoon: 'afternoon',
}

export const SINGLE_TYPE_AMOUNT = 1

export const ABSENCE_TYPES: { [key: string]: string } = {
  free: 'free',
  vacation: 'vacation',
  bankHoliday: 'bank_holiday',
  accident: 'accident',
  sickness: 'sickness',
  military: 'military',
  civilService: 'civil_service',
  school: 'school',
  unpaidVacation: 'unpaid_vacation',
  education: 'education',
  motherhood: 'motherhood',
  shortTime: 'short_time',
  freeCompensation: 'free_compensation',
  additionalFree: 'additional_free',
  compensationDay: 'compensation_day',
}

export const ABSENCE_TYPE_TRANSLATIONS: { [key: string]: string } = {
  free: 'absenceType.free',
  vacation: 'absenceType.vacation',
  bank_holiday: 'absenceType.bankHoliday',
  accident: 'absenceType.accident',
  sickness: 'absenceType.sickLeave',
  military: 'absenceType.military',
  civil_service: 'absenceType.civilService',
  school: 'absenceType.school',
  unpaid_vacation: 'absenceType.unpaidVacation',
  education: 'absenceType.education',
  motherhood: 'absenceType.parentalLeave',
  short_time: 'absenceType.shortTimeWork',
  free_compensation: 'absenceType.freeCompensation',
  additional_free: 'absenceType.additionalFree',
  compensation_day: 'absenceType.compensationDay',
}
